import React,{Component} from "react";
import SideMenu from "../components/sideMenu";
import routes from '../routes/list';
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";



class SideNav extends Component {
     setMenuOpen = () => {
        let pathname = this.props.location.pathname;
        let selectedKey = pathname
        let openKey = pathname.substr(0,pathname.lastIndexOf("/"))
        let state = {
            mode: 'inline',
            openKey: openKey,
            selectedKey: selectedKey,
            firstHide: false, 
        }
        return state
       
    }


    constructor(props){
        super(props)
        let pathname = this.props.location.pathname;
        let selectedKey = pathname
        let openKey = pathname.substr(0,pathname.lastIndexOf("/"))
         this.state = {
            mode: 'inline',
            openKey: openKey,
            selectedKey: selectedKey,
            firstHide: false, 
        }

    }

    componentDidMount(){
        let state = this.setMenuOpen()
        setTimeout(() => {
            this.setState({
                state:state
            })
        }, 0);
    }


    menuClick = (e) => {
        this.setState({
            selectedKey: e.key
        });
    };

    openMenu = (v) => {
        this.setState({
            openKey: v[v.length - 1],
            firstHide: false,
        })
    };

    render(){
        const {openKey,selectedKey,firstHide} = this.state;
        return(
            <>
                <SideMenu 
                    menus={routes.menus}
                    onClick={this.menuClick}
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    openKeys={firstHide ? null : [openKey]}
                    onOpenChange={this.openMenu}
                    {...this.props}
                />
            
            </>
        )
    }

}

export default withRouter(SideNav);